<!--begin::Heading-->
<div class="text-center pb-3">
  <img src="./assets/media/logos/free_float_platform_logo.png" alt="FF Logo" height="45" />
</div>
<div class="mb-10">
  <h3>Sign In</h3>
<!--  <p class="mb-4 text-body-tertiary">Lorem ipsum dolor sit amet elit. Sapiente sit aut eos consectetur adipisicing.</p>-->
<!--  <p class="mb-4 text-body-tertiary">Use test@test.com and password for a demo account.</p>-->
</div>
<!--end::Heading-->
<!--begin::Form-->
<form
  class="form w-100"
  [formGroup]="loginForm"
  novalidate="novalidate"
  id="loginForm"
  name="loginForm"
  (ngSubmit)="submit()">

  <!-- begin::Alert info-->
  <ng-container *ngIf="false">
    <div class="mb-10 bg-light-info p-8 rounded">
      <div class="text-info">Use your email and password to log in.</div>
    </div>
  </ng-container>
  <!-- end::Alert info-->

  <!-- begin::Alert error-->
  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
        The login details are incorrect
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="fv-row mb-10">
    <input
      class="form-control form-control-lg form-control-solid"
      type="email"
      tabindex="0"
      name="email"
      formControlName="email" placeholder="Email"
      [ngClass]="{
        'is-invalid':
          loginForm.controls['email'].dirty &&
          loginForm.controls['email'].invalid,
        'is-valid':
          loginForm.controls['email'].dirty && loginForm.controls['email'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: loginForm.controls['email']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-10">
    <input
      class="form-control form-control-lg form-control-solid mt-4"
      type="password"
      tabindex="0"
      name="password"
      placeholder="Password"
      formControlName="password"
      [ngClass]="{
        'is-invalid':
          loginForm.controls['password'].dirty &&
          loginForm.controls['password'].invalid,
        'is-valid':
          loginForm.controls['password'].dirty &&
          loginForm.controls['password'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: loginForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: loginForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: loginForm.controls['password']
      }"></ng-container>
  </div>
  <!--end::Form group-->


  <div class="d-flex mb-5 align-items-center">
    <mat-checkbox class="flex-fill" formControlName="remember_me" name="remember_me" checked="true">Remember me</mat-checkbox>
    <span><a routerLink="/auth/forgot-password" class="forgot-pass">Forgot Password</a></span>
  </div>
  <!--begin::Action-->
  <div class="text-center">
    <button
      type="submit"
      id="kt_sign_in_submit"
      class="btn btn-lg btn-primary w-100 mb-5"
      [disabled]="loginForm.invalid">
      <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(isLoading$ | async) === false">
        <span class="indicator-label">Log in</span>
      </ng-container>
    </button>

    <div class="text-body-tertiary fw-bold">
      Don't have an account?
      <a
        routerLink="{{isPremiumPlansEnabled ? '/subscribe' : '/auth/registration'}}"
        id="kt_login_signup"
        class="link-primary fw-bolder"
      >Sign up here</a
      >
    </div>

<!--        &lt;!&ndash; begin::Separator  &ndash;&gt;-->
<!--        <div class="text-center text-muted text-uppercase fw-bolder mb-5">or</div>-->
<!--        &lt;!&ndash; end::Separator  &ndash;&gt;-->

<!--        <a-->
<!--          class="-->
<!--            btn btn-flex-->
<!--            flex-center-->
<!--            btn-light btn-lg-->
<!--            w-100-->
<!--            mb-5-->
<!--            cursor-pointer-->
<!--          "-->
<!--        >-->
<!--          <img-->
<!--            class="h-20px me-3"-->
<!--            src="./assets/media/svg/brand-logos/google-icon.svg"-->
<!--          />-->

<!--          Continue with Google-->
<!--        </a>-->
  </div>
  <!--end::Action-->
</form>
<!--end::Form-->

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation">
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container text-danger">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  </ng-container>
</ng-template>
